/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExistingClientResponseListPagedBaseResponse as ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse } from '../../models/Models/v3/LoanManagement/existing-client-response-list-paged-base-response';

export interface V3LoanManagementClientsPagedGet$Xml$Params {
  firstName?: string;
  lastName?: string;
  dob?: string;
  email?: string;
  mobile?: string;
  settlementDate?: string;
  pageNumber?: number;
  pageSize?: number;
}

export function v3LoanManagementClientsPagedGet$Xml(http: HttpClient, rootUrl: string, params?: V3LoanManagementClientsPagedGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementClientsPagedGet$Xml.PATH, 'get');
  if (params) {
    rb.query('firstName', params.firstName, {});
    rb.query('lastName', params.lastName, {});
    rb.query('dob', params.dob, {});
    rb.query('email', params.email, {});
    rb.query('mobile', params.mobile, {});
    rb.query('settlementDate', params.settlementDate, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>;
    })
  );
}

v3LoanManagementClientsPagedGet$Xml.PATH = '/v3/loan-management/clients-paged';
